import { checkboxAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";
import { disabledProps } from "./disabled";
import { focusProps } from "./focus";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(checkboxAnatomy.keys);

const baseStyle = definePartsStyle({
  label: {},
  container: {
    alignItems: "flex-start",
  },
  control: {
    borderWidth: "1px",
    borderColor: "gray.300",
    mt: 1,
    _disabled: disabledProps,
    _focus: focusProps,
  },
});

export const radioTheme = defineMultiStyleConfig({
  baseStyle,
  defaultProps: { colorScheme: "primary" },
});
